import React, { useRef, useState, useEffect, useContext  } from "react";
import * as S from "./FlorenzInputDate.style.js";
import * as P from "../../../utils/pipes.js";
import { ThemeContext } from 'styled-components';
import { useTranslation } from "react-i18next";

function  FlorenzInputDate({ 
  label,
  value,
  getText,
  disabled,
  required,
  forWhiteBackgroud=true, 
  time
}) {  
  const container = useRef(null);
  const textInput = useRef(null);
  const [active, setActive] = useState(false);
  const { t } = useTranslation("global");

  useEffect(() => {
    const handleClickOutside = e => {
      if (!container.current.contains(e.target)) {
        setActive(false)
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const activeInput = () => {    
    if (!disabled) {
      textInput.current.focus(); 
      setActive(true);
    } 
  } 
  

  return (
    <S.FlorenzInputDate
      active={active} 
      disabled={disabled} 
      forWhiteBackgroud={forWhiteBackgroud}
      required={required}
    >
      <div className="label">
        <div className="label__text">{label || t("globally.date")}</div>
        {
          !value &&
          <div className="label__required warning">
            {required ? "*" : ""}
          </div>
        }
        {
          value && <i className="label__icon icon zaia-i-check-1"></i>
        }
      </div>
      <div className="input-container" onClick={() => activeInput()} ref={container}>      
        <input 
          ref={textInput}
          type={time? "time" : "date"}
          onChange={(event) => {
            getText(event.target.value)
          }}
          value={value}
          onWheel={(e) => e.target.blur()}
          onKeyDown={(e) => {
            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
              e.preventDefault();
            }
          }}
        />       
      </div>
    </S.FlorenzInputDate>
  );
}

export default FlorenzInputDate;
